const ssoEn = {
  empty: 'No software available',
  home: 'Home',
  searchPlaceholder: 'Find Software...',
  title: 'Single Sign On',
  viewAll: 'View all',
};

export default ssoEn;
